import { Router } from '@angular/router';
import { AdalService } from 'adal-angular4';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NotificationService } from '../notification.service';
import { Injectable, ErrorHandler, Injector, NgZone } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private readonly logout = 'Login/Logout';

  constructor(private adal: AdalService, public commonService: CommonService, public restApiService: RestApiService, private injector: Injector, private ngZone: NgZone, private notificationService: NotificationService) {
    this.adal.init({
      tenant: environment.tenant,
      clientId: environment.clientId,
      cacheLocation: environment.cacheLocation,
      localLoginUrl: environment.localLoginUrl,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.postLogoutRedirectUri
    });
  }

  handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      this.ngZone.run(() => {
        if (error["status"] == 401) {
          this.notificationService.showPopup("Unauthorized request", "Warning").then(
            x => this.Logout(this.commonService.getLoggedInUserStatus())
          );
        }

        if (error["status"] == 400 && error.error == "You have logged in with your account in another device. The current session is closed") {
          this.notificationService.showPopup("You have logged in with your account in another device. The current session is closed", "Warning").then(
            x => this.Logout(this.commonService.getLoggedInUserStatus(), true)
          );
        }
      });
    }
  }

  private Logout(_isInternal: boolean, _isSoftLogout: boolean = false): void {
    const router = this.injector.get(Router);

    if (_isSoftLogout) {
      if (_isInternal) {
        sessionStorage.clear();
        localStorage.clear();
        this.adal.logOut();
      }

      if (!_isInternal) {
        sessionStorage.clear();
        localStorage.clear();
        router.navigate(['/authentication/login']);
      }
    }
    else {
      let user = {
        emailId: this.commonService.getLoggedInUserEmailId(),
        isInternal: _isInternal,
        isLogoutTime: true
      }

      this.restApiService.new_POST(this.logout, user).subscribe((data: any) => {
        if (_isInternal) {
          sessionStorage.clear();
          localStorage.clear();
          this.adal.logOut();
        }

        if (!_isInternal) {
          sessionStorage.clear();
          localStorage.clear();
          router.navigate(['/authentication/login']);
        }
      });
    }
  }

}
